export default __webpack_public_path__ + "static/media/LOGO COULEUR-300.e113aff4.png";